import { hasCommandModifier, hasShiftKey } from '../../utils/keyboard/keyboardUtility';

export const isAttemptingMultiSelect = (event) => hasShiftKey(event) || hasCommandModifier(event);
